import { render } from "./TheGlobalFileInput.vue?vue&type=template&id=62dd57dc&ts=true"
import script from "./TheGlobalFileInput.vue?vue&type=script&lang=ts"
export * from "./TheGlobalFileInput.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__